

export default function basicNavigation() {

    const $window = $(window),
            $html = $('html'),
            $body = $('body'),
            $header = $('.header'),
            $overlay = $('.back-to-top-overlay'),
            navbarHeight = $header.outerHeight();


    let didScroll,
        lastScrollTop = 0,
        delta = 5,
        initialLoad = true,
        colourThreshold = 500,
        threshold = 500,
        headerTogglable = $header.hasClass('header-togglable'),
        headerState = 'dark',
        headerVisible = true,
        backToTopVisible = false;

    // const setHeaderLight = () => {
    //     if (headerTogglable && headerState !== 'light') {
    //         $header.removeClass('header-dark').addClass('header-light');
    //         headerState = 'light';
    //     }
    // };
    //
    // const setHeaderDark = () => {
    //     if (headerTogglable && headerState !== 'dark') {
    //         $header.removeClass('header-light').addClass('header-dark');
    //         headerState = 'dark';
    //     }
    // };

    const setHeaderVisible = () => {
        $header.removeClass('header-hidden');
        headerVisible = true;
    };

    const setHeaderHidden = () => {
        $header.addClass('header-hidden');
        headerVisible = false;
    };

    const setBackToTopVisible = () => {
        $overlay.addClass('back-to-top-visible');
        backToTopVisible = true;
    };

    const setBackToTopHidden = () => {
        $overlay.removeClass('back-to-top-visible');
        backToTopVisible = false;
    };

    const hasScrolled = () => {
        let st = $window.scrollTop();

        if (Math.abs(lastScrollTop - st) > delta) {

            if (st > lastScrollTop && st > navbarHeight) {
                setHeaderHidden();
                setBackToTopHidden();
            } else {

                // if (st > colourThreshold) {
                //     setHeaderLight();
                // } else {
                //     setHeaderDark();
                // }

                if (st + $window.height() < $(document).height()) {

                    if (st > threshold) {
                        if (st > $window.height()) setBackToTopVisible();
                    } else {
                        setBackToTopHidden();
                    }
                    setHeaderVisible();
                }
            }

            lastScrollTop = st;
        }

        if (initialLoad) {
            if (st < threshold) setHeaderVisible();
            initialLoad = false;
        }
    };


    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 100);


    $window.scroll(function(){
        didScroll = true;
    }).scroll();

}
